module.exports = __webpack_public_path__ + "static/img/zeta_template_03.27b68c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeta_template_03.png
// module id = LCD7
// module chunks = 1